import b from 'b_';
import cx from 'classnames';
import { Text } from 'platform-components';
import React from 'react';
import { accessibleClick } from '@edu-frontend/modules/src/shared/lib/a11y';

import './spec-course-tabs.scss';

interface Props {
    onTabClick: () => void;
    isActive: boolean;
}
export const SpecCourseTabs = (props: Props) => {
    const { onTabClick, isActive } = props;

    return (
        <div className="spec-course-tabs">
            <div className={b('spec-course-tabs', 'tab', { active: isActive })} {...accessibleClick(onTabClick)}>
                <Text id="specCourse.content.tabs.active" />
            </div>
            <div
                className={cx(b('spec-course-tabs', 'tab', { active: !isActive }), 'qa_spec-courses_tab_completed')}
                {...accessibleClick(onTabClick)}
            >
                <Text id="specCourse.content.tabs.complete" />
            </div>
        </div>
    );
};
